__turbopack_context__.v({
  "buttonRow": "SaveTripButton-module__1D0KPG__buttonRow",
  "container": "SaveTripButton-module__1D0KPG__container",
  "dialog": "SaveTripButton-module__1D0KPG__dialog",
  "dialogBody": "SaveTripButton-module__1D0KPG__dialogBody",
  "dialogFooter": "SaveTripButton-module__1D0KPG__dialogFooter",
  "dialogHeader": "SaveTripButton-module__1D0KPG__dialogHeader",
  "error": "SaveTripButton-module__1D0KPG__error",
  "errorIcon": "SaveTripButton-module__1D0KPG__errorIcon",
  "label": "SaveTripButton-module__1D0KPG__label" + " " + __turbopack_context__.i(942504)["saveButton"] + " " + __turbopack_context__.i(942504)["noUnderline"],
  "saving": "SaveTripButton-module__1D0KPG__saving",
});
